import { Component, Input } from "@angular/core";
import { TissueCollectionType } from "../../shared/services/request.service";
import { RequestedSampling } from "../review-request/review-request.model";

@Component({
    selector: "app-sampling-needs-grid",
    templateUrl: "./sampling-needs-grid.component.html"
})
export class SamplingNeedsGridComponent {
    @Input() requestedSamplings: RequestedSampling[];
    @Input() includeNotes: boolean;

    public get displayGrowthStage(): boolean {
        return this.requestedSamplings.some(r => r.growthStage !== null);
    }
    
    public get displayDaysAfterPlanting(): boolean {
        return this.requestedSamplings.some(r => r.daysAfterPlanting !== null);
    }

    constructor() { }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/view-request/sampling-needs-grid/sampling-needs-grid.component.ts